import * as firebase from 'firebase';

const config = {
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.FIREBASE_DATABASE_URL,
    projectId: process.env.FIREBASE_PROJECT_ID,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.FIREBASE_APP_ID
};

firebase.initializeApp(config);

const database = firebase.database();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();


export { firebase, googleAuthProvider, database as default };


// Basic usage of .once() to read the data located at ref.
// database.ref.once('globals/labels')
//     .then(function (dataSnapshot) {
//         // handle read data.
//         console.log(dataSnapshot)
//     });


// db.ref().set({
//     name: "Gern Blanstan",
//     gender: "Female",
//     age: 56,
//     stressLevel: 6,
//     job: {
//         title: 'Developer',
//         company: 'Google'
//     },
//     hobbies: {
//         tennis: true,
//         golf: false,
//         knitting: true
//     },
//     location: {
//         city: "Omaha",
//         state: "Nebraska",
//         country: "U.S."
//     }
// }).then(() => {
//     console.log("Data saved")
// }).catch((e) => {
//     console.log('Data write failed', e)
// })

// db.ref().update({
//     stressLevel: 9,
//     'job/company': 'Amazon',
//     'location/city': 'Seattle',
//     'location/state': 'Washington'
// })

// db.ref().on('value', (snapshot) => {
//     const val = snapshot.val();
//     console.log(`${val.name} is a ${val.job.title} at ${val.job.company}`);
// })

// setTimeout(() => {
//     db.ref('job/company').set('Microsoft')
// }, 1000)

// const mapObjToExpense = (ss) => {
//     const expenses = []
//     ss.forEach((child) => {
//         expenses.push({
//             id: child.key,
//             ...child.val()
//         })

//     })
//     //console.log('mapObjToExpenses: ', expenses)
// }


// init db - delete all data
// db.ref().set({})
//     .then(() => {

//         console.log('All data cleared')

//         db.ref('expenses').push({
//             description: 'Rent',
//             note: '',
//             amount: 109500,
//             createdAt: 976123498763
//         });

//         db.ref('expenses').push({
//             description: 'Food',
//             note: '',
//             amount: 10300,
//             createdAt: 976123498863
//         });

//         db.ref('expenses').push({
//             description: 'Cable',
//             note: '',
//             amount: 10000,
//             createdAt: 976123498963
//         });


//         db.ref('expenses')
//             .once('value')
//             .then((ss) => {
//                 mapObjToExpense(ss)

//             }).catch((e) => {
//                 console.log('Fetch Error: ', e)
//             }).then(() => {
//                 // note: .on does not support promises
//                 db.ref('expenses').on('value', (ss) => {
//                     mapObjToExpense(ss)

//                 })
//             })





//     }).catch((e) => {
//         console.log('Error clearing data', e)
//     })

// // child changed
// db.ref('expenses').on('child_changed', (ss) => {
//     console.log('child changed: ', ss.key, ss.val())
// })

// // child changed
// db.ref('expenses').on('child_added', (ss) => {
//     console.log('child added: ', ss.key, ss.val())
// })



// setTimeout(() => {
//     db.ref('expenses').push({
//         description: 'Last Child',
//         note: '',
//         amount: 10,
//         createdAt: 975123498963
//     });

// }, 5000)



// const retRef = db.ref('expenses').push();
// console.log('returned ref from push()', retRef.key)
// retRef.push({
//     description: 'Wood',
//     note: '',
//     amount: 1299,
//     createdAt: 976123498763
// });

// setTimeout(() => {
//     retRef.update({
//         parent: 'Parent Expense'
//     })

// }, 5000)








// db.ref('attributes').set({
//     weight: 220,
//     height: 72
// }).then(() => {
//     console.log("Data saved")
// }).catch((e) => {
//     console.log('Data write failed', e)
// })

//  console.log('Request to save data started..')


// const adaRef = firebase.database().ref('isSingle');
// adaRef.remove()
//     .then(function () {
//         console.log("Remove succeeded.")
//     })
//     .catch(function (error) {
//         console.log("Remove failed: " + error.message)
//     });


// WEBPACK FOOTER //
// ./src/firebase/firebase.js